import React, { useEffect, useState } from "react";
import { fetchCourseByCourseId } from "../../api/courseApi";
import { fetchCourseVideoByCourseId } from "../../api/courseVideoApi";
import Loading from "../common/Loading";
import { Link, useNavigate } from "react-router-dom";
import ToastService from "../../services/ToastService";
import Modal3Js from "../Modal3Js";
import { useSelector } from "react-redux";

const CourseMenuLession = ({ courseId, lessonId }) => {
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  const [dataCourseVideo, setDataCourseVideo] = useState(null);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fetchDataCourseVideo = async () => {
    try {
      const data = await fetchCourseVideoByCourseId({ courseId: courseId, userId : user && user.guid });

      if (data) {
        setDataCourseVideo(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  useEffect(() => {
    setTimeout(fetchDataCourseVideo, 500);
  }, []);

  const handleNavigateTo = (item) => {
    if (item.isOpenFormAddMoney) {
      setIsModalOpen(true)
    } else {
      navigate('/course/' + courseId + '/lessons/' + item.id)
    }
  }

  return (
    <>
      {
        isModalOpen && <Modal3Js
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Notification"
          submitText="Confirm"
          cancelText="Cancel"
        >

          <p>Please <Link to={'/course/' + courseId} data-router-disabled="">buy this course</Link> or <Link to={'/pricing'} data-router-disabled="">upgrade</Link> to package Gold or Diamond to watch this lesson!
                    </p>
                    <p>If you don't have money on your account, <Link to={'/account/mywallet'} data-router-disabled="">click here</Link> to add money to your account.
                    </p>


          <div className="buttons">

            {/* <Link to="/account/addmoney" data-router-disabled="" className="button is-purple">
                <span className="hover"></span>
                <span className="label">


                  Nạp tiền


                </span>
              </Link> */}

            <button className="js-close button" onClick={() => {
              setIsModalOpen(false)
            }}>
              <span className="hover"></span>
              <span className="label">
                Close
              </span>
            </button>

          </div>
        </Modal3Js>
      }

      {dataCourseVideo && (
        <aside
          className="js-lessons-list lessons-list"
          style={
            isShowMenu
              ? { transform: "translate(0)" }
              : { transform: "translate(-100%)" }
          }
        >
          <button
            className="js-toggle-button toggle-button"
            onClick={() => {
              setIsShowMenu(!isShowMenu);
            }}
          >
            <div className="shadow-fix">
              <span className="hover"></span>
              <span className="bar bar-1">
                <span className="inner"></span>
              </span>
              <span className="bar bar-2">
                <span className="inner"></span>
              </span>
              <span className="bar bar-3">
                <span className="inner"></span>
              </span>
              <span className="bar bar-4">
                <span className="inner"></span>
              </span>
              <span className="bar bar-5">
                <span className="inner"></span>
              </span>
            </div>
          </button>
          <div className="scroll-container">
            <div className="js-scroll-mover scroll-mover">
              {dataCourseVideo.courseVideos &&
                dataCourseVideo.courseVideos.map((item, index) => {
                  return (
                    <>
                      <section className="js-chapter chapter-container">
                        <div className="js-chapter-head chapter">
                          <div className="label">Chapter {index + 1}</div>
                          <div
                            className="title mt-2"
                            style={{ fontSize: "20px" }}
                          >
                            {item.title}
                          </div>

                          <div className="progress">
                            <div className="circle">
                              <svg height="38" width="38" className="full">
                                <circle
                                  cx="19"
                                  cy="19"
                                  r="17"
                                  stroke="black"
                                  stroke-width="4"
                                  fill="transparent"
                                />
                              </svg>
                              <svg height="38" width="38" className="fill">
                                <circle
                                  className="js-chapter-circle"
                                  cx="19"
                                  cy="19"
                                  r="17"
                                  stroke="black"
                                  stroke-width="4"
                                  fill="transparent"
                                  data-circle-length="106.81415022206"
                                  stroke-dasharray="106.81415022206"
                                  stroke-dashoffset="95.469714453357"
                                />
                              </svg>
                            </div>
                            <div className="js-chapter-percentage percentage">
                              11
                            </div>
                          </div>
                        </div>

                        <div className="list">
                          {item.children &&
                            item.children.map((itemChildren, indexChild) => {
                              return (
                                <>
                                  <div
                                    className={
                                      itemChildren.id === lessonId
                                        ? "js-lesson lesson is-current is-active"
                                        : "js-lesson lesson"
                                    }
                                  >
                                    <Link
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleNavigateTo(itemChildren)
                                      }}
                                      className="link"
                                    >
                                      <span className="background"></span>
                                      <span className="title">
                                        {indexChild + 1}. {itemChildren.title}
                                      </span>
                                      <span className="duration">35:24</span>
                                      {itemChildren.isPreview ? (
                                        <>
                                          <span className="badge is-free">
                                            free
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          <span className="badge is-sneak-peek">
                                            sneak peek
                                          </span>
                                        </>
                                      )}
                                    </Link>

                                    <div
                                      data-url-do="https://threejs-journey.com/api/lessons/status/1/1"
                                      data-url-undo="https://threejs-journey.com/api/lessons/status/1/0"
                                      className="js-status status"
                                    >
                                      <div className="icon">
                                        <div className="to-do"></div>
                                        <div className="done">
                                          <div className="inner">
                                            <svg
                                              version="1.1"
                                              id="Calque_1"
                                              x="0px"
                                              y="0px"
                                              viewBox="0 0 9.9 9"
                                            >
                                              <path d="M5.3,8.4l4.3-6c0.5-0.7,0.4-1.6-0.3-2.1C8.6-0.2,7.7-0.1,7.2,0.6L3.8,5.3L2.4,4.1C1.8,3.6,0.8,3.7,0.3,4.3c-0.5,0.6-0.4,1.6,0.2,2.1l2.7,2.2C3.5,8.9,3.8,9,4.2,9h0.1C4.8,8.9,5.1,8.7,5.3,8.4z" />
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="active">
                                          <div className="inner">
                                            <svg
                                              version="1.1"
                                              id="Calque_1"
                                              x="0px"
                                              y="0px"
                                              viewBox="0 0 10.5 11.8"
                                            >
                                              <path
                                                className="st0"
                                                d="M0,1.5c0-1.2,1.3-1.9,2.3-1.3l7.5,4.4c1,0.6,1,2,0,2.6l-7.5,4.4c-1,0.6-2.3-0.1-2.3-1.3V1.5z"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="sparkles">
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                        <div className="sparkle">
                                          <div className="inner"></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                      </section>
                    </>
                  );
                })}
            </div>

            <div className="shadow-overlay"></div>
          </div>
        </aside>
      )}
    </>
  );
};

export default CourseMenuLession;
